import React, { FC } from 'react';

const IconAzoka: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 36 36"
      {...props}
    >
      <g>
        <defs>
          <path
            id="SVGID_1_"
            d="M18,0.05c-6.62,0-11.98,5.37-11.98,12c0,3.28,1.31,6.25,3.44,8.41l0,0c7.46,7.55,8.4,13.77,8.51,15.3h0.08
			c0.11-1.53,1.05-7.75,8.51-15.3l0,0c2.13-2.17,3.44-5.13,3.44-8.41C29.98,5.42,24.62,0.05,18,0.05L18,0.05z"
          />
        </defs>
        <clipPath id="SVGID_2_">
          <use href="#SVGID_1_" />
        </clipPath>
        <rect
          x="6.02"
          y="0.05"
          className="azoka-st0"
          width="11.98"
          height="11.98"
        />
        <rect
          x="18"
          y="0.05"
          className="azoka-st1"
          width="11.98"
          height="11.98"
        />
        <rect
          x="6.02"
          y="12.03"
          className="azoka-st2"
          width="11.98"
          height="11.98"
        />
        <rect
          x="18"
          y="12.03"
          className="azoka-st3"
          width="11.98"
          height="11.98"
        />
        <rect
          x="6.02"
          y="24.01"
          className="azoka-st4"
          width="11.98"
          height="11.98"
        />
        <rect
          x="18"
          y="24.01"
          className="azoka-st5"
          width="11.98"
          height="11.98"
        />
      </g>
    </svg>
    // <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
    //            x="0px" y="0px"
    //            viewBox="0 0 36 36" style="enable-background:new 0 0 36 36;" xml:space="preserve" {...props}>
    // <style type="text/css">
    // 	.st0{clip - path:url(#SVGID_2_);fill:#606060;}
    //   .st1{clip - path:url(#SVGID_2_);fill:#5C5B5C;}
    //   .st2{clip - path:url(#SVGID_2_);fill:#666666;}
    //   .st3{clip - path:url(#SVGID_2_);fill:#545454;}
    //   .st4{clip - path:url(#SVGID_2_);fill:#787878;}
    //   .st5{clip - path:url(#SVGID_2_);fill:#6E6E6E;}
    // </style>
    //         <g>
    // 	<defs>
    // 		<path id="SVGID_1_" d="M18,0.05c-6.62,0-11.98,5.37-11.98,12c0,3.28,1.31,6.25,3.44,8.41l0,0c7.46,7.55,8.4,13.77,8.51,15.3h0.08
    // 			c0.11-1.53,1.05-7.75,8.51-15.3l0,0c2.13-2.17,3.44-5.13,3.44-8.41C29.98,5.42,24.62,0.05,18,0.05L18,0.05z"/>
    // 	</defs>
    //           <clipPath id="SVGID_2_">
    // 		<use href="#SVGID_1_" style="overflow:visible;"/>
    // 	</clipPath>
    //           <rect x="6.02" y="0.05" className="st0" width="11.98" height="11.98"/>
    //           <rect x="18" y="0.05" className="st1" width="11.98" height="11.98"/>
    //           <rect x="6.02" y="12.03" className="st2" width="11.98" height="11.98"/>
    //           <rect x="18" y="12.03" className="st3" width="11.98" height="11.98"/>
    //           <rect x="6.02" y="24.01" className="st4" width="11.98" height="11.98"/>
    //           <rect x="18" y="24.01" className="st5" width="11.98" height="11.98"/>
    // </g>
    // </svg>
  );
};

export default IconAzoka;
